import module from 'fan/proyecto/module.js'

export class FanProyectoConfiguracionZonaSalarialService {
  constructor($http) {
    this.$http = $http
  }

  put(proyectoId, data) {
    return this.$http.put('/api2/proyecto/configuracion/zona-salarial', data, {
      params: {proyectoId},
    })
  }
}

module.service('FanProyectoConfiguracionZonaSalarial', FanProyectoConfiguracionZonaSalarialService)



// WEBPACK FOOTER //
// ./src/fan/proyecto/services/Proyecto/Configuracion/ZonaSalarial.js